
import { CardV2 } from "pepsico-ds";

const PHKPICard = ({ slotContent, className=null }) => {
    return (
      <CardV2
        className={className? `${className} ph-course-card` :"ph-course-card"}
        cardBody={{
          isDark: false,
          type: 'slot',
          slot: (
            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                fontFamily: 'Inter',
                padding: "24px"
              }}
            >
  
              {/* This is where the value from your prop is rendered */}
              {slotContent}
              
            </div>
          ),
        }}
        maxScrollHeight="90px"
        state="interactive"
        type="basic"
        viewport="desktop"
      />
    );
  };
 
export { PHKPICard } 